import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const N = { navy:'#20396B', bubblegum:'#F2A7C0', blush:'#FBDDE6', cream:'#FCF6EC', sunny:'#FFC84B', teal:'#36B7A6', tealLight:'#d0f0ec', white:'#fff' };

export default function TutorDashboard({ onStartSession, onLogout }) {
  const [students, setStudents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [tab, setTab] = useState('students');
  const [newStudent, setNewStudent] = useState({ name:'', student_code:'', student_pin:'', parent_pin:'' });
  const [showAdd, setShowAdd] = useState(false);
  const [weeklyUpdate, setWeeklyUpdate] = useState({ lesson_goals:'', homework:'' });
  const [materials, setMaterials] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchStudents(); }, []);
  useEffect(() => { if (selected) { fetchMaterials(selected.id); fetchWeeklyUpdate(selected.id); } }, [selected]);

  const fetchStudents = async () => { const { data } = await supabase.from('students').select('*').order('name'); setStudents(data || []); };
  const fetchWeeklyUpdate = async (id) => {
    const { data } = await supabase.from('weekly_updates').select('*').eq('student_id', id).order('created_at', { ascending: false }).limit(1).single();
    setWeeklyUpdate(data ? { lesson_goals: data.lesson_goals||'', homework: data.homework||'' } : { lesson_goals:'', homework:'' });
  };
  const fetchMaterials = async (id) => { const { data } = await supabase.from('materials').select('*').eq('student_id', id).order('created_at', { ascending: false }); setMaterials(data||[]); };

  const addStudent = async () => {
    if (!newStudent.name || !newStudent.student_code || !newStudent.student_pin || !newStudent.parent_pin) { setMsg('Please fill in all fields!'); return; }
    if (newStudent.student_pin.length !== 4 || newStudent.parent_pin.length !== 4) { setMsg('PINs must be 4 digits!'); return; }
    const { error } = await supabase.from('students').insert([{ name: newStudent.name, student_code: newStudent.student_code.toUpperCase(), student_pin: newStudent.student_pin, parent_pin: newStudent.parent_pin }]);
    if (error) { setMsg('Error: ' + error.message); return; }
    setMsg('Student added!'); setShowAdd(false); setNewStudent({ name:'', student_code:'', student_pin:'', parent_pin:'' }); fetchStudents();
    setTimeout(() => setMsg(''), 2000);
  };

  const saveWeeklyUpdate = async () => {
    if (!selected) return;
    setSaving(true);
    const { data: ex } = await supabase.from('weekly_updates').select('id').eq('student_id', selected.id).order('created_at', { ascending: false }).limit(1).single();
    if (ex) await supabase.from('weekly_updates').update({ lesson_goals: weeklyUpdate.lesson_goals, homework: weeklyUpdate.homework, updated_at: new Date().toISOString() }).eq('id', ex.id);
    else await supabase.from('weekly_updates').insert([{ student_id: selected.id, lesson_goals: weeklyUpdate.lesson_goals, homework: weeklyUpdate.homework }]);
    setSaving(false); setMsg('Saved!'); setTimeout(() => setMsg(''), 2000);
  };

  const uploadMaterial = async () => {
    if (!uploadFile || !selected) return;
    setSaving(true);
    const path = `${selected.id}/${Date.now()}_${uploadFile.name}`;
    const { error: upErr } = await supabase.storage.from('materials').upload(path, uploadFile);
    if (upErr) { setMsg('Upload failed'); setSaving(false); return; }
    const { data: urlData } = supabase.storage.from('materials').getPublicUrl(path);
    await supabase.from('materials').insert([{ student_id: selected.id, file_name: uploadFile.name, file_url: urlData.publicUrl, file_path: path }]);
    setUploadFile(null); setSaving(false); setMsg('Uploaded!'); fetchMaterials(selected.id); setTimeout(() => setMsg(''), 2000);
  };

  const deleteMaterial = async (mat) => {
    await supabase.storage.from('materials').remove([mat.file_path]);
    await supabase.from('materials').delete().eq('id', mat.id);
    fetchMaterials(selected.id);
  };

  const btn = (bg, color, border) => ({ background: bg, color, border: border ? `2px solid ${border}` : 'none', borderRadius: 12, padding: '10px 20px', fontSize: 14, cursor: 'pointer', fontWeight: 700, fontFamily: 'var(--font-body)' });
  const input = { width:'100%', padding:'10px 12px', borderRadius:12, border:'2px solid #e8edf5', fontSize:14, outline:'none', background:'#fff', marginBottom:4, fontFamily:'var(--font-body)' };
  const label = { fontSize:13, color:'#8a9ab8', display:'block', marginBottom:6, marginTop:12, fontWeight:700 };
  const card = (bg) => ({ background: bg||N.white, borderRadius:16, padding:'20px 22px', boxShadow:'0 2px 10px rgba(32,57,107,0.07)', marginBottom:16 });

  const sidebarItems = [
    { key:'students', icon:'👩‍🎓', label:'Students' },
    { key:'weekly', icon:'📋', label:'Lesson & Homework' },
    { key:'materials', icon:'📁', label:'Materials' },
  ];

  return (
    <div style={{ minHeight:'100vh', background:N.cream, display:'flex', flexDirection:'column' }}>
      {/* Header */}
      <div style={{ background:N.navy, padding:'14px 28px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:24 }}>🐰</span>
          <div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:18, fontWeight:700, color:'#fff' }}>OkieDokie Academy</div>
            <div style={{ fontSize:11, color:N.bubblegum, fontWeight:700, letterSpacing:1 }}>TUTOR DASHBOARD</div>
          </div>
        </div>
        <button onClick={onLogout} style={{ background:'rgba(255,255,255,0.15)', border:'none', borderRadius:10, padding:'7px 16px', cursor:'pointer', fontSize:13, color:'#fff', fontFamily:'var(--font-body)', fontWeight:600 }}>Log out</button>
      </div>

      <div style={{ display:'flex', flex:1 }}>
        {/* Sidebar */}
        <div style={{ width:220, background:N.white, borderRight:`2px solid ${N.blush}`, padding:'20px 12px', display:'flex', flexDirection:'column', gap:4 }}>
          {sidebarItems.map(item => (
            <button key={item.key} onClick={() => setTab(item.key)} style={{ padding:'11px 14px', borderRadius:12, cursor:'pointer', background: tab===item.key ? N.blush : 'transparent', color: tab===item.key ? N.navy : '#8a9ab8', fontFamily:'var(--font-body)', fontSize:14, fontWeight: tab===item.key ? 700 : 600, border:'none', textAlign:'left', width:'100%', display:'flex', alignItems:'center', gap:8 }}>
              {item.icon} {item.label}
            </button>
          ))}
          {selected && (
            <div style={{ marginTop:'auto', padding:'12px 14px', background:N.tealLight, borderRadius:12 }}>
              <div style={{ fontSize:11, color:N.teal, fontWeight:700, marginBottom:4 }}>SELECTED</div>
              <div style={{ fontSize:14, fontWeight:700, color:N.navy }}>{selected.name}</div>
              <button onClick={() => onStartSession(selected)} style={{ ...btn(N.teal,'#fff'), width:'100%', marginTop:10, padding:'9px', fontSize:13 }}>
                Start Live Session 🚀
              </button>
            </div>
          )}
        </div>

        {/* Main */}
        <div style={{ flex:1, padding:'28px 32px', overflowY:'auto' }}>

          {/* STUDENTS TAB */}
          {tab === 'students' && (
            <>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
                <div style={{ fontFamily:'var(--font-head)', fontSize:22, fontWeight:700, color:N.navy }}>Your Students</div>
                <button style={btn(N.navy,'#fff')} onClick={() => setShowAdd(!showAdd)}>+ Add Student</button>
              </div>
              {showAdd && (
                <div style={card(N.blush)}>
                  <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, marginBottom:4, color:N.navy }}>New Student</div>
                  {[['name','Full Name','text'],['student_code','Student ID (e.g. OKD-2025-EMMA)','text'],['student_pin','Student PIN (4 digits)','password'],['parent_pin','Parent PIN (4 digits, different from student)','password']].map(([key,lbl,type]) => (
                    <div key={key}>
                      <label style={label}>{lbl}</label>
                      <input style={input} type={type} value={newStudent[key]} maxLength={key.includes('pin')?4:50}
                        onChange={e => setNewStudent(p => ({...p,[key]:e.target.value}))}
                        autoComplete="off" spellCheck={false} autoCorrect="off" />
                    </div>
                  ))}
                  <button style={{ ...btn(N.navy,'#fff'), marginTop:14 }} onClick={addStudent}>Save Student</button>
                  {msg && <div style={{ color:N.teal, fontSize:13, marginTop:8, fontWeight:600 }}>{msg}</div>}
                </div>
              )}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:14 }}>
                {students.map(st => (
                  <div key={st.id} onClick={() => setSelected(st)} style={{ background: selected?.id===st.id ? N.navy : N.white, border:`2px solid ${selected?.id===st.id ? N.navy : N.blush}`, borderRadius:18, padding:'18px 14px', cursor:'pointer', textAlign:'center', boxShadow: selected?.id===st.id ? '0 4px 16px rgba(32,57,107,0.25)' : '0 2px 8px rgba(32,57,107,0.06)', transition:'all 0.15s' }}>
                    <div style={{ fontSize:32 }}>🐰</div>
                    <div style={{ fontWeight:700, marginTop:8, color: selected?.id===st.id ? '#fff' : N.navy, fontFamily:'var(--font-head)', fontSize:15 }}>{st.name}</div>
                    <div style={{ fontSize:11, color: selected?.id===st.id ? N.bubblegum : '#8a9ab8', marginTop:2, fontWeight:600 }}>{st.student_code}</div>
                  </div>
                ))}
              </div>
              {msg && !showAdd && <div style={{ color:N.teal, fontSize:13, marginTop:8, fontWeight:600 }}>{msg}</div>}
            </>
          )}

          {/* WEEKLY / HOMEWORK TAB */}
          {tab === 'weekly' && (
            <>
              <div style={{ fontFamily:'var(--font-head)', fontSize:22, fontWeight:700, color:N.navy, marginBottom:20 }}>Lesson Notes & Homework</div>
              {!selected ? (
                <div style={card(N.blush)}>
                  <div style={{ color:'#8a9ab8', fontSize:14 }}>👈 Select a student from the Students tab first.</div>
                </div>
              ) : (
                <div style={card()}>
                  <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, color:N.navy, marginBottom:14 }}>{selected.name}</div>

                  <div style={{ background:N.tealLight, borderRadius:12, padding:'14px 16px', marginBottom:14 }}>
                    <label style={{ ...label, marginTop:0, color:N.teal }}>📋 What we covered today / Lesson goals</label>
                    <textarea style={{ ...input, minHeight:90, resize:'vertical', marginBottom:0 }} value={weeklyUpdate.lesson_goals}
                      onChange={e => setWeeklyUpdate(p => ({...p, lesson_goals:e.target.value}))}
                      placeholder="e.g. Today we covered subject-verb agreement and practised comprehension cloze..." />
                    <div style={{ fontSize:12, color:N.teal, marginTop:4, fontWeight:600 }}>Visible to student and parent</div>
                  </div>

                  <div style={{ background:N.blush, borderRadius:12, padding:'14px 16px' }}>
                    <label style={{ ...label, marginTop:0, color:'#c04060' }}>✏️ Homework for this week</label>
                    <textarea style={{ ...input, minHeight:90, resize:'vertical', marginBottom:0 }} value={weeklyUpdate.homework}
                      onChange={e => setWeeklyUpdate(p => ({...p, homework:e.target.value}))}
                      placeholder="e.g. Complete grammar worksheet pages 3–4. Read the passage on page 5 and answer Q1–Q3..." />
                    <div style={{ fontSize:12, color:'#c04060', marginTop:4, fontWeight:600 }}>Visible to student and parent</div>
                  </div>

                  <button style={{ ...btn(N.navy,'#fff'), marginTop:16 }} onClick={saveWeeklyUpdate} disabled={saving}>
                    {saving ? 'Saving...' : 'Save Update ✓'}
                  </button>
                  {msg && <div style={{ color:N.teal, fontSize:13, marginTop:8, fontWeight:600 }}>✅ {msg}</div>}
                </div>
              )}
            </>
          )}

          {/* MATERIALS TAB */}
          {tab === 'materials' && (
            <>
              <div style={{ fontFamily:'var(--font-head)', fontSize:22, fontWeight:700, color:N.navy, marginBottom:20 }}>Materials</div>
              {!selected ? (
                <div style={card(N.blush)}><div style={{ color:'#8a9ab8', fontSize:14 }}>👈 Select a student from the Students tab first.</div></div>
              ) : (
                <div style={card()}>
                  <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, color:N.navy, marginBottom:12 }}>Upload for {selected.name}</div>
                  <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', marginBottom:16 }}>
                    <input type="file" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" onChange={e => setUploadFile(e.target.files[0])} style={{ fontSize:13 }} />
                    <button style={btn(N.teal,'#fff')} onClick={uploadMaterial} disabled={saving||!uploadFile}>
                      {saving ? 'Uploading...' : 'Upload'}
                    </button>
                    {msg && <span style={{ color:N.teal, fontSize:13, fontWeight:600 }}>✅ {msg}</span>}
                  </div>
                  <div style={{ fontWeight:700, marginBottom:8, color:N.navy, fontSize:14 }}>Uploaded Files</div>
                  {materials.length === 0 && <div style={{ color:'#8a9ab8', fontSize:13 }}>No files yet.</div>}
                  {materials.map(mat => (
                    <div key={mat.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 0', borderBottom:`1px solid ${N.blush}` }}>
                      <a href={mat.file_url} target="_blank" rel="noreferrer" style={{ color:N.teal, fontSize:14, fontWeight:700, textDecoration:'none', display:'flex', alignItems:'center', gap:8 }}>📄 {mat.file_name}</a>
                      <button onClick={() => deleteMaterial(mat)} style={{ background:N.blush, border:'none', borderRadius:8, padding:'4px 10px', cursor:'pointer', fontSize:12, color:'#c04060', fontFamily:'var(--font-body)', fontWeight:600 }}>Remove</button>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

        </div>
      </div>
    </div>
  );
}
